var map = {
	"./calendar.html": 36,
	"./calendarDayView.html": 37,
	"./calendarHourList.html": 38,
	"./calendarMonthCell.html": 39,
	"./calendarMonthCellEvents.html": 40,
	"./calendarMonthView.html": 41,
	"./calendarSlideBox.html": 42,
	"./calendarWeekView.html": 43,
	"./calendarYearView.html": 44
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10;


//////////////////
// WEBPACK FOOTER
// ./src/templates nonrecursive \.html
// module id = 10
// module chunks = 0